import graphql from "babel-plugin-relay/macro";

const UsersStatisticsQuery = graphql`
query UsersStatisticsQuery($userId: String!){
  usersStatistics(userId:$userId){
    user{
      joinedAt
    }  
    marketCurrentTotal
    profitLoss
    invested
    percentageDiff
    grantMoney
  }
}
`

export default UsersStatisticsQuery;